module.exports = __webpack_public_path__ + "static/media/vondozeb_80.eb4757e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/climasense/sigatoka_negra/alternative/vondozeb_80.png
// module id = 1170
// module chunks = 3